<template>
	<div>
		<div class="form-group"></div>
		<template v-if="roleRules.DISCIPLINE_FLG === 'Y'">
			<section v-for="(school, idx) in schools" :key="`school-${idx}`">
				<h2 v-if="school.length > 0">
					{{ school[0].SCHOOL_TITLE }}
				</h2>
				<div class="table-responsive" v-if="school.length > 0">
					<table-editable-list :columns="columns"
															:show-select="false"
															:show-actions="false">
						<template slot="data-row">
							<template v-for="(incident, index) in school">
								<table-list-row :columns="columns"
																:rowdata="incident"
																:rowIndex="index"
																:showActions="false"
																:key="`Incident_${idx}_${index}`">
									<template slot="infractions">
										<ul>
											<template v-for="(infraction, j) in incident.INFRACTIONS">
												<li v-if="infraction.length" :key="j">{{infraction}}</li>
											</template>
										</ul>
									</template>
									<template slot="actionsTaken">
										<ul>
											<template v-for="(action, j) in incident.ACTIONS">
												<li v-if="action.length" :key="j">{{action}}</li>
											</template>
										</ul>
									</template>
									<template slot="description" v-if="!!incident.INCIDENT_DESC">
										<div class="text-center">
											<button v-if="incident.INCIDENT_DESC.length" @click="openDescriptionModal(incident)" class="btn btn-default">
												{{ $t('MAIN_CONTENT.Discipline.showDescription') }}
											</button>
										</div>
									</template>
								</table-list-row>
							</template>
						</template>
					</table-editable-list>
				</div>
				<div class="alert alert-info" v-if="school.length === 0">
					{{ $t('MAIN_CONTENT.Discipline.noIncidents') }}
				</div>
			</section>
			<div class="alert alert-info" v-if="Object.keys(schools).length === 0">
				{{ $t('MAIN_CONTENT.Discipline.noIncidents') }}
			</div>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.commonContent.invalidPermissions') }}
		</template>

		<modal :modal-title="$t('MAIN_CONTENT.Discipline.incidentModalTitle', { description: selectedIncident.DATE_TIME } )"
					 :show="showDescriptionModal"
					 dialog-size="lg"
					 name="incidentDescription"
					 fields=""
					 @close="closeDescriptionModal()">
			<div v-html="selectedIncident.INCIDENT_DESC"></div>
			<template slot="footer" :close="closeDescriptionModal">
				<button type="button" class="btn btn-default" @click="closeDescriptionModal">
					{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters, mapState } from 'vuex';
	import Discipline from '../api/Discipline';
	import Modal from 'COMMONS/shared/Modal/Modal.vue';
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		name: 'Discipline',
		data() {
			return {
				schools: [],
				showDescriptionModal: false,
				selectedIncident: {},
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
			columns() {
				let columns = [];

				columns.push({
					heading: this.$t('MAIN_CONTENT.Discipline.date'),
					key: 'DATE_TIME',
					customCol: 'date'
				});

				if(this.roleRules.DISCIPLINE_INFRACTION_FLG === 'Y') {
					columns.push({
						heading: this.$t('MAIN_CONTENT.Discipline.infractions'),
						key: 'INFRACTIONS',
						customCol: 'infractions',
						type: 'list'
					});
				}

				if(this.roleRules.DISCIPLINE_ACTION_FLG === 'Y') {
					columns.push({
						heading: this.$t('MAIN_CONTENT.Discipline.actionTaken'),
						key: 'ACTIONS',
						customCol: 'actionsTaken',
						type: 'list'
					});
				}

				if(this.roleRules.DISCIPLINE_OFFICIAL_DESC_FLG === 'Y') {
					columns.push({
						heading: this.$t('MAIN_CONTENT.Discipline.description'),
						key: 'INCIDENT_DESC',
						customCol: 'description'
					});
				}

				return columns;
			}
		},
		components: {
			TableEditableList,
			TableListRow,
			Modal
		},
		methods: {
			loadDisciplineData() {
				const self = this;

				let discipline = new Discipline({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID
					}
				});

				const promise = discipline.get();

				promise.then(response => {
					self.$set(self, 'schools', response.data.data);

					for(let i in self.schools) {
						let school = self.schools[i];

						for(let x in school) {
							let incident = school[x];

							self.$set(incident, 'DATE_TIME', moment(incident.DISPLAY_DATE).format('MM/DD/YYYY - hh:mm A'));
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
			},
			openDescriptionModal(incident){
				this.showDescriptionModal = true;
				this.selectedIncident = incident;
			},
			closeDescriptionModal(incident){
				this.showDescriptionModal = false;
				this.selectedIncident = {};
			},
		},
		created() {
			this.$store.commit('setTitleIcon', 'gavel');
			this.$store.commit('setTitle', 'MAIN_CONTENT.Discipline.sideMenuDisciplineLink');
			this.$store.commit('setUseHeader', true);

			if(this.roleRules.DISCIPLINE_FLG === 'Y') {
				this.loadDisciplineData();
			} else {
				this.$router.push({ name: 'HomePage' });
			}
		}
	}
</script>
